import React from 'react';
import { Progress } from 'antd';

interface ProcessingScreenProps {
  currentStep: number;
}

export const ProcessingScreen: React.FC<ProcessingScreenProps> = ({
  currentStep,
}) => {
  const steps = [
    {
      number: [1],
      title: 'Uploading Document',
    },
    {
      number: [2, 3],
      title: 'Scanning Content',
    },
    {
      number: [4, 5, 6, 7],
      title: 'Extracting Data',
    },
  ];

  // Calculate progress for each step
  const getStepPercent = (stepNum: number) => {
    if (currentStep > stepNum || (currentStep === stepNum && currentStep === 7))
      return 100;
    if (currentStep === stepNum && (currentStep === 6 || currentStep === 3))
      return 80;
    if (currentStep === stepNum && currentStep === 5) return 50;
    if (currentStep === stepNum && currentStep === 4) return 30;
    if (currentStep === stepNum && currentStep === 2) return 20;
    return 0;
  };

  return (
    <div
      style={{
        minHeight: '240px',
        background: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 8,
        width: '100%',
      }}
    >
      <div style={{ width: '100%' }}>
        {/* Progress Steps */}
        <div>
          {steps.map((group, idx) => {
            const inGroup = group.number.includes(currentStep);
            const stepPercent = inGroup
              ? currentStep
              : group.number[group.number.length - 1];
            return (
              <div
                key={idx}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 14,
                }}
              >
                <div
                  style={{
                    width: 25,
                    height: 25,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontWeight: 'bold',
                    background:
                      currentStep >= group.number[0] ? '#1677ff' : '#d9d9d9',
                    marginRight: 16,
                    flexShrink: 0,
                    fontSize: 12,
                  }}
                >
                  {idx + 1}
                </div>
                <div style={{ flex: 1 }}>
                  <div
                    style={{ fontSize: 15, fontWeight: 600, color: '#02103d' }}
                  >
                    {group.title}
                  </div>
                  <Progress
                    percent={getStepPercent(stepPercent)}
                    showInfo={false}
                    strokeColor="#1677ff"
                    trailColor="#f0f0f0"
                    style={{ margin: '4px 0', width: '100%' }}
                  />
                  <div style={{ fontSize: 16, color: '#666' }}></div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Loading indicator for current step */}
        {currentStep <= 7 && (
          <div style={{ marginTop: 16, textAlign: 'center' }}>
            <div style={{ color: '#666' }}>
              {currentStep === 1 && 'Uploading your document...'}
              {(currentStep === 2 || currentStep === 3) &&
                'Scanning and analyzing content...'}
              {(currentStep === 4 ||
                currentStep === 5 ||
                currentStep === 6 ||
                currentStep === 7) &&
                'Extracting structured data...'}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
